import React, { FC, ReactNode } from "react";
import { Grid } from "@material-ui/core";

interface Props {
  id?: string;
  children: ReactNode;
  style?: React.CSSProperties;
}

/**
 * Components hides the first (empty) colum of 12 for XS / mobile view
 * and shows it for SM and up
 * @param props the component to be render as child
 */
export const ResponsiveGrid: FC<Props> = (props: Props) => {
  return (
    <Grid container id={props.id} style={props.style}>
      <Grid item xs={12}>
        {props.children}
      </Grid>
    </Grid>
  );
};
